export default (width = 26, height = 26, color = '#F5F5F5') => `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 26 26">
        <g fill="none" fill-rule="evenodd" stroke="#309A02" stroke-width="1.5">
            <circle cx="13" cy="13" r="12.25" fill="${color}"/>
            <path d="M21 3L5.5 22.5M5 3l15.5 19.5"/>
        </g>
    </svg>
`